import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { DocumentUploadWizardComponent } from './document-upload-wizard.component';

@NgModule({
    declarations: [
        DocumentUploadWizardComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        NgSelectModule
    ],
    exports: [
        DocumentUploadWizardComponent
    ]
})
export class DocumentUploadWizardModule { }
